<template>
  <div>
    <rectangle v-for='(rect,i) in maskRects' :parent-container='screenContainer'
                                             :bounds='rect'
                                             :render-tools='renderTools'
                                             :alpha='0.9'
                                             :key='i'
                                             :fill-color='0x000000'
                                             :line-width='0'
                                             />
  </div>
</template>
<script>
import Rectangle from '@edit/atoms/Rectangle.vue';
export default {
  props: {
    size: {
      type: Object,
      default() {
        return {
          cols:10,
          rows:10
        }
      }
    },
    screenContainer: {
      type: Object,
      required: true
    },
    container: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    }

  },
  components: {
    Rectangle
  },
  computed:{
    maskRects() {
      const max = 90;
      const left = -this.size.cols/2;
      const right = this.size.cols/2;
      const top = -this.size.rows/2;
      const bottom = this.size.rows/2;

      const rects = [
        {x1:-max, y1:-max, x2:max, y2:top},

        {x1:-max, y1:top, x2:left, y2:bottom},
        {x1:right, y1:top, x2:max, y2:bottom},
        {x1:-max, y1:bottom, x2:max, y2:max},
      ]
      return rects;
    },
    bounds() {
      const x1 = -10;
      const x2 = 10;
      const y1 = -10;
      const y2 = 10;
      return {
        x1,
        x2,
        y1,
        y2
      }
    }
  }
}
</script>
